
import React from 'react';

const ModalYesorNo = ({ idModal, doBtn, color, text, Click, byLoading, stateLoad, children }) => {


    let mainByLoading = false;
    if (byLoading) mainByLoading = true;




    return (

        <>

            <div className="modal fade" data-bs-backdrop="static" id={idModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  >
                <div className="modal-dialog modal-dialog-centered">

                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        {mainByLoading ?

                            stateLoad ?


                                <div className={`d-flex flex-column justify-content-center align-items-center m-4 `} style={{ height: "100px", color: `#7545fb` }}>
                                    <div className="spinner-border" role="status"></div>
                                </div>


                                :

                                <>

                                    <div className="modal-body d-flex flex-column row-gap-3 align-items-start">
                                        {text}
                                        {children}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal" >انصراف</button>
                                        <button type="button" className={`btn btn-sm text-white btn-${color === undefined ? "danger" : color}`} data-bs-dismiss="modal" onClick={() => Click()} >{doBtn}</button>
                                    </div>


                                </>
                            :

                            <>


                                <div className="modal-body">
                                    {text}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal" >انصراف</button>
                                    <button type="button" className={`btn btn-sm text-white btn-${color === undefined ? "danger" : color}`} data-bs-dismiss="modal" onClick={() => Click()} >{doBtn}</button>
                                </div>


                            </>

                        }





                    </div>

                </div>
            </div>


        </>
    );
};

export default ModalYesorNo;